<template>
  <div class="content blacklist">
    <div class="header">
      <div class="row">
        <div class="box">
          <div class="title">分销商信息</div>
          <el-input
            size="small"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="input2">
          </el-input>
        </div>
        <div class="box">
          <div class="title">分销商等级</div>
          <el-input
            size="small"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="input2">
          </el-input>
        </div>
        <div class="box">
          <div class="title">提现方式</div>
          <el-input
            size="small"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="input2">
          </el-input>
        </div>
        <div class="box">
          <div class="title">申请时间</div>
          <el-input
            size="small"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="input2">
          </el-input>
        </div>
        
      </div>
    </div>
    <template>
      <el-table :data="tableData" style="width: 100%" size="small">
        <el-table-column prop="sort" label="分销商名称" width="140"></el-table-column>
        <el-table-column prop="title" label="分销商等级" ></el-table-column>
        <el-table-column prop="title" label="体现方式" ></el-table-column>
        <el-table-column prop="title" label="申请佣金" ></el-table-column>
        <el-table-column prop="title" label="实际佣金" ></el-table-column>
        <el-table-column prop="title" label="提现手续费" ></el-table-column>
        <el-table-column prop="title" label="申请时间时间" ></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text">同意</el-button>
            <el-button type="text" @click="deleteRow(scope.$index, scope)">拒绝</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      page_id: "",
      tableData: [
        {
          imgUrl: "https://ae01.alicdn.com/kf/U632dc163d48d4d34a74088ca4c8e49b5W.png",
          sort: "1",
          name: "dsfsd电风扇",
          link: "",
          state: 1
        }
       ]
    };
  },
  mounted() {
    this.page_id = this.$route.params.id;
    this.getLocalData();
  },
  methods: {
    // 获取数据
    getLocalData() {
      this.tableData = JSON.parse(localStorage.getItem("sliceList"))
    },
    // 删除行
    deleteRow(index, row) {
      console.log(index, row);
      this.tableData.splice(index, 1)
      localStorage.setItem("sliceList", JSON.stringify(this.tableData));
    },
    addSlice() {
      this.$router.push({
        path: `adAdvertisement`
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.blacklist {
  padding: 10px 25px;
  .header {
    padding: 10px 10px;
    
    .row{
      display: flex;
      padding: 6px 0;
    }
    .box{
      width: 25%;
      line-height: 40px;
      display: flex;
      .title{
        width:120px;
        padding-right: 20px;
        text-align: right;
      }
    }
  }
  .img {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    img {
      width: 80%;
    }
  }
}
</style>

<style lang="scss">
.blacklist {
  .has-gutter > tr > th {
    color: #333;
    background-color: #f8f8f8;
  }
  .cell {
    text-align: center;
  }
}
</style>
